import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  .detalhes-captacao-title {
    width: 100%;
    height: 24px;
    color: var(--Preto-Principal, #1c1d22);
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.2px;

    margin-bottom: 8px;
  }
  .error-message {
    color: red;
    width: 100%;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
  }
  .detalhes-captacao-subtitle {
    color: var(--Preto-Principal, #070707);
    font-family: 'Roboto';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.14px;

    margin-bottom: 16px;
  }

  .status-card-captacao {
    display: flex;
    align-items: center;
    color: ${Theme.pallete.QUINARY};

    gap: 10px;
    margin-bottom: 20px;

    width: 100%;
    height: 26px;

    font-family: 'Roboto';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px; /* 185.714% */
    letter-spacing: 0.2px;
  }

  .status-card-captacao-img {
    width: 16px;
    height: 16px;
    filter: ${Theme.icons.QUATERNARY};
    margin-bottom: 5px;
  }

  .status-card-container-cards {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap: 16px 20px;
    margin-left: 1px;
    padding-bottom: 32px;
  }

  .detalhes-container123 {
    display: flex;
    align-items: center;
    gap: 10px;

    margin-bottom: 32px;
  }

  .detalhes-edit-icon {
    width: 16px;
    height: 16px;

    margin-bottom: 16px;
  }

  .detalhes-botoes-container {
    display: flex;
    align-items: center;
    gap: 32px;
  }

  .status-icon {
    width: 12px;
    height: 12px;
    margin-left: 10px;
    border-radius: 50%;

    background-color: ${Theme.pallete.QUINARY};
    filter: ${Theme.icons.QUATERNARY};
  }

  .status-span {
    color: var(--Preto-Principal, #070707);
    font-family: 'Roboto';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.14px;
  }
`
